// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qz2gd","left":"styles_left__2yJUR","desktopActions":"styles_desktopActions__3_3R_","title":"styles_title__2Ao2g"};